// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--b7231";
export var accordions = "Accordion-module--accordions--bbb67";
export var button = "Accordion-module--button--716e6";
export var panel = "Accordion-module--panel--a80fb";